module.exports = __webpack_public_path__ + "img/ico-instagram-2x.a232f292.png";